import React from 'react';
import roomInspectorIcon from '../../../images/room_inspector.png';
import cartIcon from '../../../images/guestInit.png';
import { MONITOR_DOOR_FOOTER_ICON_MIN_HEIGHT_PX } from './monitorDoorCardModel';

/**
 * Shared cart / room-inspector footer row for monitor door cards and compact circles.
 */
export default function MonitorCartInspectorFooterRow({
    layout,
    icon_blink_interval = 0,
    blink = true,
    className = '',
    style = {}
}) {
    if (!layout?.monitorHasBottomFooter) return null;

    const initialsOpacity = icon_blink_interval > 0 ? (blink ? 1 : 0) : 1;

    return (
        <div
            className={`monitor-door-card-v2__cart-row d-flex align-items-center justify-content-center ${className}`.trim()}
            style={{
                minHeight: MONITOR_DOOR_FOOTER_ICON_MIN_HEIGHT_PX,
                maxHeight: MONITOR_DOOR_FOOTER_ICON_MIN_HEIGHT_PX,
                ...style
            }}
        >
            {layout.isRoomInspectorForMonitorFooter ? (
                <>
                    {layout.cartDisplayShowIcon === 1 && (
                        <img src={roomInspectorIcon} alt="" style={{ width: 20, flexShrink: 0 }} />
                    )}
                    <span
                        className="text-black text-uppercase text-center ms-1"
                        style={{
                            lineHeight: 1,
                            opacity: initialsOpacity,
                            transition: 'opacity 0.2s',
                            fontSize: 11
                        }}
                    >
                        {layout.cartDisplayInitials}
                    </span>
                </>
            ) : layout.cartDisplayInitials ? (
                layout.cartDisplayShowIcon === 1 ? (
                    <div className="monitor-door-card-v2__cart-icon">
                        <img src={cartIcon} alt="" className="monitor-door-card-v2__cart-img" />
                        <span
                            className="monitor-door-card-v2__cart-initials text-white text-uppercase text-center"
                            style={{
                                lineHeight: 1,
                                opacity: initialsOpacity,
                                transition: 'opacity 0.2s'
                            }}
                        >
                            {layout.cartDisplayInitials}
                        </span>
                    </div>
                ) : (
                    <span
                        className="text-black text-uppercase text-center"
                        style={{
                            lineHeight: 1,
                            opacity: initialsOpacity,
                            transition: 'opacity 0.2s',
                            fontSize: 11
                        }}
                    >
                        {layout.cartDisplayInitials}
                    </span>
                )
            ) : null}
        </div>
    );
}
